import { Skeleton } from 'antd';

import './rowSkeleton.scss';

interface Props {
    rowsCount: number;
}

export const RowSkeleton: React.FC<Props> = ({ rowsCount = 1 }) => {
    return (
        <div className="row-skeleton-container">
            <div className="row-skeleton-content">
                {Array.from({ length: rowsCount }).map((_, index) => (
                    <Skeleton.Input key={index} className="row-skeleton-input" active />
                ))}
            </div>
        </div>
    );
};
